import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { AutoFixHigh as WandIcon } from '@mui/icons-material';
import React from 'react';

import { CutDescriptionsSection } from './sections/cut-descriptions-section';
import { ExtrasDescriptionsSection } from './sections/extras-descriptions-section';
import { SpecificationDescriptionsSection } from './sections/specification-descriptions-section';
import { TrimDescriptionsSection } from './sections/trim-descriptions-section';
import { WelcomeMessageSection } from './sections/welcome-message-section';

interface WizardBuilderProps {
  wizardWelcomeTitle?: string;
  wizardWelcomeContent?: string;
}

export const defaultWelcomeTitle = 'Hi there!';
export const defaultWelcomeContent = `This will take about 5-10 minutes.

• You'll see pictures and descriptions for every cut.
• We'll explain the trade-offs between different options.
• You can go back and change your mind at any time.
• We'll show you a complete summary before submitting.`;

export function WizardBuilder(_props: WizardBuilderProps) {
  return (
    <Box sx={{ mt: -3 }}>
      <Card
        sx={{
          mb: 3,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          bgcolor: 'background.paper',
        }}
      >
        <CardHeader
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backdropFilter: 'blur(8px)',
            py: 3,
            px: 3,
          }}
          avatar={<WandIcon sx={{ fontSize: '3rem', color: 'primary.main' }} />}
          title={
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontSize: '1.75rem',
                color: 'text.primary',
                letterSpacing: '-0.02em',
              }}
            >
              Wizard Builder
            </Typography>
          }
          subheader={
            <Typography
              variant="body1"
              sx={{
                mt: 0.5,
                color: 'text.secondary',
                fontSize: '1rem',
              }}
            >
              Customize the cutsheet wizard experience for your customers
            </Typography>
          }
        />
        <CardContent sx={{ p: 3 }}>
          <Stack spacing={3}>
            <WelcomeMessageSection />
            <SpecificationDescriptionsSection />
            <CutDescriptionsSection />
            <TrimDescriptionsSection />
            <ExtrasDescriptionsSection />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
